import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class SettingsService {

    constructor(
        private http: HttpClient
    ) { }

    getSettings(): Observable<any> {
        const url = `${environment.api}/settings`;
        return this.http.get<Observable<any>>(url);
    }

    editSettings(body, settingsId: number): Observable<any> {
        const url = `${environment.api}/settings/${settingsId}`;
        return this.http.put<Observable<any>>(url, body);
    }
}